(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var animationFrame = 0;
  var animationToken = 0;

  function visibleHeight(element) {
    if (!element) return 0;

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    if (style.display === 'none' || style.visibility === 'hidden' || rect.height <= 0) {
      return 0;
    }

    return rect.height;
  }

  function anchorOffset() {
    if (window.matchMedia('(max-width: 798px)').matches) {
      return Math.max(visibleHeight(document.getElementById('header')), 102) + 18;
    }

    var sticky = document.querySelector('.sticky_nav');
    var stickyHeight = visibleHeight(sticky);

    if (stickyHeight > 0 && sticky.getBoundingClientRect().top <= 2) {
      return stickyHeight + 18;
    }

    var navigation = document.querySelector('[data-desktop-header] .mm-desktop-header__navigation');
    return Math.max(visibleHeight(navigation) + 64, 113) + 18;
  }

  function targetTravel(target) {
    if (
      window.matchMedia('(min-width: 799px)').matches &&
      (target.id === 'shop-paths' || target.id === 'holder-finder')
    ) {
      return 32;
    }

    return 0;
  }

  function targetPosition(target) {
  var position =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    anchorOffset() +
    targetTravel(target);

  if (target.id === 'holder-finder') {
    var finderButton = target.querySelector(
      '.mmv3-finder__actions .mmv3-button--primary'
    );

    if (finderButton) {
      var buttonBottom =
        finderButton.getBoundingClientRect().bottom +
        window.pageYOffset;

      var desiredBottom =
        position +
        window.innerHeight -
        32;

      if (buttonBottom > desiredBottom) {
        position += buttonBottom - desiredBottom;
      }
    }
  }

  return Math.max(0, position);
}

  function stopAnimation() {
    animationToken += 1;

    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = 0;
    }
  }

  function settleTarget(target) {
    if (!target || !document.documentElement.contains(target)) return;

    var correctedTop = targetPosition(target);
    if (Math.abs(window.pageYOffset - correctedTop) > 2) {
      window.scrollTo(0, correctedTop);
    }
  }

  function animateTo(target, onComplete) {
    stopAnimation();

    var token = animationToken;
    var startTop = window.pageYOffset;
    var endTop = targetPosition(target);
    var distance = endTop - startTop;

    if (reducedMotion.matches || Math.abs(distance) < 3) {
      window.scrollTo(0, endTop);
      settleTarget(target);
      if (onComplete) onComplete();
      return;
    }

    var duration = Math.min(620, Math.max(380, Math.abs(distance) * 0.32));
    var startTime = window.performance.now();

    function frame(now) {
      if (token !== animationToken) return;

      var progress = Math.min(1, (now - startTime) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, startTop + distance * eased);

      if (progress < 1) {
        animationFrame = window.requestAnimationFrame(frame);
        return;
      }

      animationFrame = 0;
      settleTarget(target);
      window.setTimeout(function () { settleTarget(target); }, 100);
      window.setTimeout(function () { settleTarget(target); }, 420);
      if (onComplete) onComplete();
    }

    animationFrame = window.requestAnimationFrame(frame);
  }

  function moveTo(target, updateHistory, instant) {
    if (!target) return;

    var focusTarget = target.matches('input, select, textarea, button, [tabindex="-1"]');

    if (updateHistory && window.history && window.history.pushState) {
      var hash = '#' + target.id;
      if (window.location.hash !== hash) {
        window.history.pushState(null, '', hash);
      }
    }

    if (instant || reducedMotion.matches) {
      stopAnimation();
      window.scrollTo(0, targetPosition(target));
      settleTarget(target);
      window.setTimeout(function () { settleTarget(target); }, 120);

      if (focusTarget) {
        target.focus({ preventScroll: true });
      }
      return;
    }

    animateTo(target, function () {
      if (focusTarget) {
        target.focus({ preventScroll: true });
      }
    });
  }

  function decodedHash(value) {
    try {
      return decodeURIComponent(value.replace(/^#/, ''));
    } catch (error) {
      return value.replace(/^#/, '');
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;

    var targetId = link.getAttribute('data-mm-scroll-target');

    if (!targetId) {
      var destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
      targetId = decodedHash(destination.hash);
    }

    var target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    event.preventDefault();
    moveTo(target, true, false);
  });

  ['wheel', 'touchstart'].forEach(function (eventName) {
    window.addEventListener(eventName, stopAnimation, { passive: true });
  });

  window.addEventListener('keydown', function (event) {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].indexOf(event.key) !== -1) {
      stopAnimation();
    }
  });

  window.addEventListener('hashchange', function () {
    var id = decodedHash(window.location.hash);
    var target = id ? document.getElementById(id) : null;

    if (target && target.closest('.mmv3')) {
      window.setTimeout(function () {
        moveTo(target, false, false);
      }, 0);
    }
  });

  window.addEventListener('load', function () {
    var id = decodedHash(window.location.hash);
    var target = id ? document.getElementById(id) : null;

    if (target && target.closest('.mmv3')) {
      window.setTimeout(function () {
        moveTo(target, false, true);
      }, 80);
      window.setTimeout(function () {
        settleTarget(target);
      }, 650);
    }
  });
})();
